import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ChangeRequestsReport from './ChangeRequestsReport';

/**
 * The standalone Budget Change Requests report — the Report Centre entry, and the
 * screen revenue, ticketing and central-contingency submitters land on after a
 * submit (scoped to their own area, which is what `data-scoped` says).
 */
if (document.getElementById('budgetChangesRequests')) {
    const rootEl = document.getElementById('budgetChangesRequests');

    ReactDOM.render(
        <App>
            <ChangeRequestsReport endpoint={rootEl.dataset.endpoint} exportUrl={rootEl.dataset.exportUrl} scoped={rootEl.dataset.scoped === '1'} />
        </App>,
        rootEl,
    );
}
